<!-- vChain File Verification
Copyright 2019 vChain Inc. -->

<template>
    <div class="progress">
        <i-loader variant="dark" />
        <div class="message">{{ msgProgress }}</div>
    </div>
</template>

<style scoped lang="scss">
@import '~@inkline/inkline/src/css/config';
@import '~@inkline/inkline/src/css/mixins';

.progress {
    .loader {
        width: 60px;
        height: 60px;
        margin-bottom: -6px;
    }

    .message {
        margin-top: $spacer / 2;
    }
}
</style>

<script>
import {
    ILoader
} from '@inkline/inkline/src/components';

export default {
    name: "InProgress",
    components: {
        ILoader
    },
    computed: {
        verificationState: function() {
            return this.$store.getters.verificationState;
        },
        msgProgress: function() {
            return this.$route.query.msgProgress || this.$t("msgProgress");
        },
        progress: function() {
            return this.$store.getters.verification.progress;
        }
    }
};
</script>
